import api from "./api";

/* export const getBookDetails = async (bookId) => {
  const response = await api.get(
    `/book?book_id=${bookId}`
  );

  return response.data;
}; */


export const insertReadingSession = async (payload) => {
    try {
        const response = await api.post("/book/reading-session", payload);
        return response.data;
    } catch (error) {
        console.error("Error inserting reading session:", error);
        throw error;
    }
};

export const readAndDownloadBook = async (payload) => {
    try {
        const response = await api.post("/book/read-and-download", payload);
        return response.data;
    } catch (error) {
        console.error("Error updating book read/download status:", error);
        throw error;
    }
};

export const submitBookReviewRating = async (payload) => {
    try {
        const response = await api.post("/book/review-and-rating", payload);
        return response.data;
    } catch (error) {
        console.error("Error submitting book review and rating:", error);
        throw error;
    }
};

export const updateBookLibrary = async (payload) => {
  try {
    const response = await api.post("/book/library", payload);
    return response.data;
  } catch (error) {
    console.error("Error updating book library:", error);
    throw error;
  }
};

export const getLibrary = async (payload) => {
    try {
        const response = await api.get("/book/library", { params: payload });
        return response.data;
    } catch (error) {
        console.error("Error fetching library:", error);
        throw error;
    }
};

export const getBookReviewRating = async (payload) => {
    try {
        const response = await api.get("/book/review-and-rating", { params: payload });
        return response.data;
    } catch (error) {
        console.error("Error fetching book review and rating:", error);
        throw error;
    }
};

export const searchWithRecommendation = async (payload) => {
    try {
        const response = await api.get("/book/search-with-recommendation", {
            params: payload,
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching search recommendations:", error);
        throw error;
    }
};

export const getAutoComplete = async (payload) => {
    try {
        const response = await api.get("/book/auto-complete", {
            params: payload,
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching autocomplete suggestions:", error);
        throw error;
    }
};

export const submitWishABook = async (payload) => {
    try {
        const response = await api.post("/book/wish-a-book", payload);
        return response.data;
    } catch (error) {
        console.error("Error submitting wish a book:", error);
        throw error;
    }
};

export const getBookDetails = async (bookId) => {
    try {
        const response = await api.get(`/book?book_id=${bookId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching book details:", error);
        throw error;
    }
};

export const completeBook = async (payload) => {
    try {
        const response = await api.put("/book/book-completed", null, {params: payload});
        return response.data;
    } catch (error) {
        console.error("Error completing book:", error);
        throw error;
    }
};

export const getBookReadOfTheDay = async (payload) => {
    try {
        const response = await api.get("/book/read-of-the-day", {
            params: payload,
        });
        return response.data;
    } catch (error) {
        console.error("Get Read of the Day error:", error);
        throw error;
    }
};